"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HS_SITES = exports.DEFAULT_VALID_DOMAIN_NAMES = exports.DEFAULT_VALID_DOMAINS = exports.meetingsHubspotDomain = exports.appHubspotDomain = exports.PRICE_TIERS = exports.FEATURES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _CustomHostedDomain = _interopRequireDefault(require("MeetingsBase/models/CustomHostedDomain"));

var _Features = require("settings-ui-lib/constants/Features");

var _enviro = _interopRequireDefault(require("enviro"));

var FEATURES = (0, _keyMirror.default)({
  LINK_CUSTOMIZATION: null
});
exports.FEATURES = FEATURES;
var PRICE_TIERS = new _immutable.Map((0, _defineProperty2.default)({}, FEATURES.LINK_CUSTOMIZATION, _Features.STARTER));
exports.PRICE_TIERS = PRICE_TIERS;
var appHubspotDomain = _enviro.default.isQa('settings-ui') ? 'app.hubspotqa.com' : 'app.hubspot.com';
exports.appHubspotDomain = appHubspotDomain;
var meetingsHubspotDomain = _enviro.default.isQa('settings-ui') ? 'meetings.hubspotqa.com' : 'meetings.hubspot.com';
exports.meetingsHubspotDomain = meetingsHubspotDomain;
var DEFAULT_VALID_DOMAINS = new _immutable.List([_CustomHostedDomain.default.from({
  domain: meetingsHubspotDomain,
  isResolving: true,
  isSslEnabled: true
}), _CustomHostedDomain.default.from({
  domain: appHubspotDomain,
  isResolving: true,
  isSslEnabled: true
})]);
exports.DEFAULT_VALID_DOMAINS = DEFAULT_VALID_DOMAINS;
var DEFAULT_VALID_DOMAIN_NAMES = new _immutable.List([meetingsHubspotDomain, appHubspotDomain]);
exports.DEFAULT_VALID_DOMAIN_NAMES = DEFAULT_VALID_DOMAIN_NAMES;
var HS_SITES = 'hs-sites';
exports.HS_SITES = HS_SITES;